import React from "react";

interface MediaResourceProps {
    fileUrl: string;
    fileType: "image" | "video" | "audio";
}

const MediaResource = ({ fileUrl, fileType }: MediaResourceProps) => {
    const [hasError, setHasError] = React.useState(false);

    if (hasError) {
        return (
            <div className="text-center my-3">
                <p>This resource is currently unavailable.</p>
                <a href={fileUrl} download target="_blank" rel="noreferrer">Download file</a>
            </div>
        );
    }

    if (fileType === "image") {
        return <img src={fileUrl} alt="" style={{ maxWidth: "100%" }} onError={() => setHasError(true)} />;
    }

    if (fileType === "video") {
        return (
            <video controls style={{ width: "100%", maxWidth: "100%" }} onError={() => setHasError(true)}>
                <source src={fileUrl} />
            </video>
        );
    }

    return <audio controls src={fileUrl} style={{ width: "100%" }} onError={() => setHasError(true)} />;
};

export default MediaResource;
